import { Editor } from 'slate';
import { isEmptyString } from './is-empty-string.mjs';
import { isText } from './is-text.mjs';

function isEmpty(editor, children) {
  for (const child of children) {
    if (isText(child)) {
      if (!isEmptyString(child.text)) {
        return false;
      }
    } else if (child.type === "paragraph") {
      if (child.children.length > 1 || child.children[0] && !(isText(child.children[0]) && isEmptyString(child.children[0].text))) {
        return false;
      }
    } else {
      if (!Editor.isEmpty(editor, child)) {
        return false;
      }
    }
  }
  return true;
}

export { isEmpty };
//# sourceMappingURL=is-empty.mjs.map
